// extracted by mini-css-extract-plugin
export default {"chatAdmin":"chatAdmin_chatAdmin__KsCdZ"};